import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PushNotication } from '../_models/pushNotication';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationsService {

  private locale: string = 'pt';

  constructor(
    private http: HttpClient
  ) {
  }

  all(): Observable<PushNotication[]> {
    return this.http.get<PushNotication[]>(`${this.locale}/pushs`)
      .pipe(
        tap(_ => console.log("PushNotications fetched: ", _)),
        catchError(this.handleError)
      );
  }

  detail(id : number): Observable<PushNotication> {
    return this.http.get<PushNotication>(`${this.locale}/pushs/${id}`)
      .pipe(
        tap(_ => console.log("PushNotication fetched: ", _)),
        catchError(this.handleError)
      );
  }


  private handleError(error: Response) {
    console.error(JSON.stringify(error));
    console.error(error);
    return Observable.throw(error.statusText);
  }
}
